import React, { useState } from "react";
import { Alert, Container } from "react-bootstrap";
import styled from "styled-components";

export const AlertBoxContext = React.createContext(null);

const AlertBoxStyled = styled(Container)`
  position: fixed;
  top: 50px;
  opacity: 0.95;
  z-index: 1060;
  padding: 0px 50px 0px 50px;
`;

const AlertBoxProvider = ({ children }, ...props) => {
  const [alerts, setAlerts] = useState({});

  function addAlert(title, text, variant) {
    const rand = Math.random().toString(36).substr(2, 5);
    let newAlerts = { ...alerts };

    const keys = Object.keys(newAlerts);

    if (keys.length > 0) {
      if (text === newAlerts[keys[keys.length - 1]].text) {
        // Obtenemos el contador de la última alerta
        let contadorAlerta = newAlerts[keys[keys.length - 1]].count;
        // Borramos la altera anterior
        delete newAlerts[keys[keys.length - 1]];
        // Incrementamos el contador de la alerta repetida
        contadorAlerta++;
        // Creamos la nueva alerta con el antiguo contador
        newAlerts[rand] = { variant: variant, title: title, text: text, count: contadorAlerta };
        // Guardamos el nuevo estado
        setAlerts(newAlerts);
      } else {
        // Si no es igual que la anterior se crea nueva alerta
        newAlerts[rand] = { variant: variant, title: title, text: text, count: 1 };
        // Poner nuevas alertas
        setAlerts(newAlerts);
      }
    } else {
      // Nueva alerta
      newAlerts[rand] = { variant: variant, title: title, text: text, count: 1 };
      setAlerts(newAlerts);
    }

    // Si hay mas de tres alertas borramos la primera
    if (keys.length > 3) {
      delete newAlerts[keys[0]];
    }

    // Timeout para el borrado de la alerta
    setTimeout(function () {
      deleteAlert(rand);
    }, 6000);
  }

  // Borra una alerta por id
  // La varaible de estado 'alerts' solo esta accesible dentro de setAlerts no de la funcion en si
  function deleteAlert(id) {
    setAlerts((alerts) => {
      let newAlerts = { ...alerts };
      delete newAlerts[id];
      return newAlerts;
    });
  }

  //Estado con las funciones que permiten interactuar con la ventana modal
  const state = {
    addAlert: addAlert,
    deleteAlert: deleteAlert,
  };

  /* useImperativeHandle(ref, () => ({
    addNewAlert(title, text, variant) {
      addAlert(title, text, variant);
    },
  }));*/

  return (
    <AlertBoxContext.Provider value={state}>
      <AlertBoxStyled fluid className={props.className}>
        {Object.entries(alerts).map((value, index) => {
          const id = value[0];
          const al = value[1];
          return (
            <Alert key={id} variant={al.variant} onClose={() => deleteAlert(id)} show={true} dismissible>
              <span>
                <b>{al.title}</b>
                {al.title ? " - " : ""}
                {al.text}
                {al.count > 1 && ` (${al.count})`}
              </span>
            </Alert>
          );
        })}
      </AlertBoxStyled>
      {children}
    </AlertBoxContext.Provider>
  );
};

export default AlertBoxProvider;
